import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function isAuthorWorkoutUtil (workout, profile) {
  const authorId = getValueReduxUtil(workout, WORKOUT_KEY.AUTHOR_ID)
  const profileId = getIdReduxUtil(profile)
  if (authorId) {
    return authorId === profileId
  }
  return getValueReduxUtil(workout, WORKOUT_KEY.PROFILE_ID) === profileId
}

export { isAuthorWorkoutUtil }
